import { render, staticRenderFns } from "./ContestFaqComponent.vue?vue&type=template&id=e41550cc"
import script from "./ContestFaqComponent.vue?vue&type=script&lang=js"
export * from "./ContestFaqComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports